/**
 * Suite intake tab — a single home on the client record for everything the
 * other HardEarnedTrust apps push into Client-Base.AI:
 *   - Fact-Find.AI  → fact-find submissions          (Round X)
 *   - Risk-Profile.AI → signed risk assessments      (Round Y)
 *   - File-Note.AI  → finalised compliance file notes (Round Y)
 *
 * Each section is fed by its own intake endpoint and renders independently —
 * one section failing or being empty doesn't take the others down.
 */
import { FactFindsTab } from './FactFindsTab';
import { RiskProfilesTab } from './RiskProfilesTab';
import { FileNoteSessionsTab } from './FileNoteSessionsTab';

export function SuiteIntakeTab({ clientId }: { clientId: string }) {
  return (
    <div className="mt-6 space-y-10">
      <section>
        <h3 className="qa-eyebrow text-sm mb-3 pb-1 border-b border-hairline-paper">
          Fact-Finds <span className="text-ink-mute">· Fact-Find.AI</span>
        </h3>
        <FactFindsTab clientId={clientId} />
      </section>

      <section>
        <h3 className="qa-eyebrow text-sm mb-3 pb-1 border-b border-hairline-paper">
          Risk profiles <span className="text-ink-mute">· Risk-Profile.AI</span>
        </h3>
        <RiskProfilesTab clientId={clientId} />
      </section>

      <section>
        <h3 className="qa-eyebrow text-sm mb-3 pb-1 border-b border-hairline-paper">
          File notes <span className="text-ink-mute">· File-Note.AI</span>
        </h3>
        <FileNoteSessionsTab clientId={clientId} />
      </section>
    </div>
  );
}
